import React from "react";

import zoomLogomark from "./images/zoom-logomark.png";

type ZoomIconProps = {
	size?: number;
};

export const ZoomIcon = ({ size }: ZoomIconProps): React.ReactElement => {
	const dimension = size ?? 48;
	return <img src={zoomLogomark} alt="Zoom" width={dimension} height={dimension} />;
};
